import FloatingCTA from './FloatingCTA';
import Footer from './Footer';
import Header from './Header';

import chassisHeroImg from '../assets/shah150.jpg';
import shah12ft from '../assets/shah12ft.png';
import shah20ft from '../assets/shah20ft2.png';
import shah24ft from '../assets/shah24ft.png';
import shah30ft from '../assets/shah30ft.png';

const purchaseOptions = [
  {
    title: 'コンテナ＋シャーシセット',
    price: '150万円〜',
    text: 'ワンウェイコンテナとシャーシをセットで導入できます。',
  },
  {
    title: 'シャーシ単品',
    price: '110万円〜',
    text: 'お手持ちのコンテナや用途に合わせて、シャーシ単品でのご相談も可能です。',
  },
];

const sizeLineup = [
  { size: '12ft', length: '4,825mm', width: '2,470mm', height: '720mm' },
  { size: '20ft', length: '7,064mm', width: '2,470mm', height: '718mm' },
  { size: '24ft', length: '8,280mm', width: '2,470mm', height: '740mm' },
  { size: '30ft', length: '10,085mm', width: '2,470mm', height: '735mm' },
];

const features = [
  '全国対応',
  '日本工場製造',
  '車検対応済',
  'コンテナ固定対応',
  'カスタム対応',
  '用途に合わせたサイズ選択',
];

const detailImages = [
  { size: '12ft', src: shah12ft },
  { size: '20ft', src: shah20ft },
  { size: '24ft', src: shah24ft },
  { size: '30ft', src: shah30ft },
];

function ChassisDetail() {
  return (
    <div className="chassis-detail-page">
      <Header />
      <main className="section chassis-detail-section">
        <div className="chassis-detail-container">
          <header className="chassis-detail-header">
            <p className="container-detail-label">TRAILER CHASSIS</p>
            <h1 className="chassis-detail-title">
              コンテナを載せて、
              <br />
              もっと自由に運ぶ。
            </h1>
          </header>

          <figure className="chassis-detail-hero">
            <img src={chassisHeroImg} alt="ワンウェイコンテナとシャーシのセット販売" />
          </figure>

          <section className="chassis-detail-panel" aria-labelledby="chassis-option-title">
            <div className="container-detail-section-head">
              <p className="container-detail-label">SELECT STYLE</p>
              <h2 id="chassis-option-title" className="container-detail-heading">導入方法を選ぶ</h2>
            </div>
            <div className="chassis-option-grid">
              {purchaseOptions.map((option) => (
                <article className="chassis-option-card" key={option.title}>
                  <h3>{option.title}</h3>
                  <p className="chassis-option-price">{option.price}</p>
                  <p className="chassis-option-text">{option.text}</p>
                </article>
              ))}
            </div>
          </section>

          <section className="chassis-detail-panel" aria-labelledby="chassis-lineup-title">
            <div className="container-detail-section-head">
              <p className="container-detail-label">SIZE LINEUP</p>
              <h2 id="chassis-lineup-title" className="container-detail-heading">サイズラインナップ</h2>
            </div>
            <div className="chassis-lineup-grid">
              {sizeLineup.map((item) => (
                <article className="chassis-lineup-card" key={item.size}>
                  <h3>{item.size}</h3>
                  <dl>
                    <div>
                      <dt>全長</dt>
                      <dd>{item.length}</dd>
                    </div>
                    <div>
                      <dt>全幅</dt>
                      <dd>{item.width}</dd>
                    </div>
                    <div>
                      <dt>架台高</dt>
                      <dd>{item.height}</dd>
                    </div>
                  </dl>
                </article>
              ))}
            </div>
          </section>

          <section className="chassis-detail-panel" aria-labelledby="chassis-feature-title">
            <div className="container-detail-section-head">
              <p className="container-detail-label">SUPPORT</p>
              <h2 id="chassis-feature-title" className="container-detail-heading">対応内容</h2>
            </div>
            <ul className="chassis-feature-list">
              {features.map((feature) => (
                <li key={feature}>{feature}</li>
              ))}
            </ul>
          </section>

          <section className="chassis-detail-panel" aria-labelledby="chassis-detail-size-title">
            <div className="container-detail-section-head">
              <p className="container-detail-label">SIZE DETAIL</p>
              <h2 id="chassis-detail-size-title" className="container-detail-heading">サイズ詳細</h2>
            </div>
            <div className="chassis-size-detail-list">
              {detailImages.map((item) => (
                <figure className="chassis-size-detail-item" key={item.size}>
                  <figcaption>{item.size}</figcaption>
                  <img src={item.src} alt={`${item.size} シャーシ詳細`} />
                </figure>
              ))}
            </div>
          </section>

          <div className="container-detail-cta">
            <p className="container-detail-text">
              コンテナのサイズや設置目的に合わせて、シャーシ単品からセット導入までご相談いただけます。
            </p>
            <a href="/#contact" className="container-detail-button">
              シャーシについて相談する
            </a>
          </div>
        </div>
      </main>
      <Footer />
      <FloatingCTA />
    </div>
  );
}

export default ChassisDetail;
